<template>
  <div class="container-fluid pt-0">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>
    <!-- <div class="col-5">
      <h4 class="p-b-20">{{ $t("settings") }}</h4>
    </div> -->
    <div class="card">
      <div class="card-body">
        <div class="col-lg-8">
          <div
            v-if="mssg"
            class="
              alert alert-success alert-dismissible
              fade
              show
              text-center
              margin-bottom-1x
            "
          >
            <p class="alert-close mb-0">
              {{ mssg }}
            </p>
          </div>
          <div
            v-else-if="Errormssg"
            align="center"
            class="
              alert alert-danger alert-dismissible
              fade
              show
              text-center
              margin-bottom-1x
            "
          >
            <p class="alert-close mb-0">
              {{ Errormssg }}
            </p>
          </div>
          <form @submit.prevent="onSave">
            <div class="form-group">
              <label>{{ $t("dev-name") }}</label>
              <input
                type="text"
                name="name"
                v-model="devicename"
                class="form-control"
                required
              />
            </div>
            <div class="form-group">
              <label>{{ $t("dev_location") }}</label>
              <input
                type="text"
                name="location"
                v-model="location"
                class="form-control"
                required
              />
            </div>

            <div class="form-group">
              <label
                >{{ $t("short-desc") }}
                <span class="text-muted">150 {{ $t("words") }}</span></label
              >
              <textarea
                rows="4"
                style="resize: none"
                class="form-control"
                name="device_desc"
                v-model="deviceDescription"
                v-on:keypress="maxWords($event)"
                required
              ></textarea>
              <span
                class="text-muted"
                :style="
                  this.deviceDescription.length > 150 && 'color:red !important'
                "
                >{{ 150 - deviceDescription.length }} {{ $t("words") }}
                {{ $t("left") }}</span
              >
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("min-temp") }}</label>
                  <div class="input-group">
                    <input
                      type="number"
                      name="min_temp"
                      class="form-control"
                      v-model="mintemp"
                      required
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">°C</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("max-temp") }}</label>
                  <div class="input-group">
                    <input
                      type="number"
                      name="max_temp"
                      class="form-control"
                      v-model="maxtemp"
                      required
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">°C</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p v-if="tempmssg" class="my-0 small text-error p-1">
              {{ tempmssg }}
            </p>

            <div v-if="singledevice.type === 'box'" class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{ $t("set-point") }}</label>
                  <div class="input-group">
                    <input
                      type="number"
                      name="min_temp"
                      class="form-control"
                      v-model="preset"
                      required
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">°C</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="singledevice.type === 'box'" class="card">
              <div class="p-2 card-body">
                <div class="row">
                  <div class="col-8" style="display: flex; align-items: center">
                    {{ $t("lck-unlck") }}
                  </div>
                  <div
                    class="mb-2 col-4 pl-0 pt-2 d-flex"
                    style="justify-content: flex-end"
                  >
                    <span
                      v-if="boxstatus"
                      @click="changeboxstatus"
                      style="
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        width: 5rem;
                        justify-content: flex-end;
                        background: green;
                        border-radius: 1rem;
                      "
                    >
                      <span
                        class="border border-grey shadow-inner shadow small"
                        style="
                          width: 3rem;
                          height: 2rem;
                          background: white;
                          border-radius: 1rem;
                          display: flex;
                          justify-content: center;
                          align-items: center;
                        "
                        >{{ $t("locked") }}
                      </span>
                    </span>
                    <span
                      v-else
                      @click="changeboxstatus"
                      class="border border-grey"
                      style="
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        width: 5rem;
                        justify-content: flex-start;
                        background: gray;
                        border-radius: 1rem;
                      "
                    >
                      <span
                        class="border border-grey shadow-innershadow small"
                        style="
                          width: 3rem;
                          height: 2rem;
                          background: white;
                          border-radius: 1rem;
                          display: flex;
                          justify-content: center;
                          align-items: center;
                        "
                        >{{ $t("unlock") }}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="
                singledevice.type === 'mote' || singledevice.type === 'lora'
              "
              class="row"
            >
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("min-humid") }}</label>
                  <div class="input-group">
                    <input
                      type="number"
                      name="minHumi"
                      class="form-control"
                      v-model="minHumi"
                      required
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">%</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("max-humid") }}</label>
                  <div class="input-group">
                    <input
                      type="number"
                      name="maxHumi"
                      class="form-control"
                      v-model="maxHumi"
                      required
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p
              v-if="humimssg && singledevice.type === 'mote'"
              class="my-0 mb-2 small text-error p-1"
            >
              {{ humimssg }}
            </p>

            <!-- <div v-if="singledevice.type === 'mote'" class="form-group">
              <label class="mb-0">{{ $t("int") }}</label>
              <p class="small gray4">
                {{ $t("rate") }}
              </p>
              <div class="input-group">
                <input
                  type="number"
                  name="interval"
                  class="form-control"
                  v-model="interval"
                  required
                />
                <div class="input-group-append">
                  <span class="input-group-text">{{ $t("mins") }}</span>
                </div>
              </div>
            </div> -->

            <!-- <div
              v-if="
                profile.role !== 'staff' && singledevice.type === 'mote'
              "
              class="card"
            >
              <div class="p-2 card-body">
                <div class="row">
                  <div class="col-8" style="display: flex; align-items: center">
                    {{ $t("mk-pub-priv") }}
                  </div>
                  <div
                    class="mb-2 col-4 pl-0 pt-2 d-flex"
                    style="justify-content: flex-end"
                  >
                    <span
                      v-if="status === 'private'"
                      @click="changemotestatus('public')"
                      style="
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        width: 5rem;
                        justify-content: flex-end;
                        background: green;
                        border-radius: 1rem;
                      "
                    >
                      <span
                        class="border border-grey shadow-inner shadow"
                        style="
                          width: 3rem;
                          height: 2rem;
                          background: white;
                          border-radius: 1rem;
                          display: flex;
                          justify-content: center;
                          align-items: center;
                        "
                        >{{ $t("priv") }}
                      </span>
                    </span>
                    <span
                      v-else
                      @click="changemotestatus('private')"
                      class="border border-grey"
                      style="
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        width: 5rem;
                        justify-content: flex-start;
                        background: gray;
                        border-radius: 1rem;
                      "
                    >
                      <span
                        class="border border-grey shadow-innershadow"
                        style="
                          width: 3rem;
                          height: 2rem;
                          background: white;
                          border-radius: 1rem;
                          display: flex;
                          justify-content: center;
                          align-items: center;
                        "
                        >{{ $t("public") }}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div> -->

            <div class="row m-t-20">
              <div class="form-group col-md-5">
                <button type="submit" class="btn btn-primary">
                  {{ $t("save") }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "DeviceSettings",
  data() {
    return {
      devicename: "",
      mintemp: "",
      maxtemp: "",
      minHumi: "",
      maxHumi: "",
      preset: "",
      interval: "",
      status: "",
      boxstatus: "",
      tempmssg: "",
      humimssg: "",
      deviceDescription: "",
      isLoading: false,
      fullPage: true,
      Errormssg: "",
      mssg: "",
      location: "",
    };
  },
  mounted() {
    this.devicename = this.singledevice.settings.name;
    this.mintemp = this.singledevice.settings.minTemperature;
    this.minHumi = this.singledevice.settings.minHumidity;
    this.maxtemp = this.singledevice.settings.maxTemperature;
    this.preset = this.singledevice.settings.preset;
    this.maxHumi = this.singledevice.settings.maxHumidity;
    this.interval = this.singledevice.settings.interval;
    this.status = this.singledevice.status;
    this.boxstatus = this.singledevice.settings.lock;
    if (this.singledevice.settings.description)
      this.deviceDescription = this.singledevice.settings.description;
    this.location = this.singledevice.settings.location;
  },
  components: {
    Loading,
  },
  computed: {
    ...mapGetters(["singledevice", "profile"]),
  },
  methods: {
    ...mapActions(["updateDevice", "fetchDeviceDetails"]),
    changemotestatus(params) {
      this.status = params;
    },
    changeboxstatus() {
      this.boxstatus = !this.boxstatus;
    },
    onSave() {
      if (this.deviceDescription.length > 150) return;
      this.tempmssg = "";
      this.humimssg = "";
      if (Number(this.mintemp) > Number(this.maxtemp)) {
        this.tempmssg =
          "Minimum temperature cannot be greater than maximum temperature";
      } else if (Number(this.minHumi) > Number(this.maxHumi)) {
        this.humimssg =
          "Minimum humidity cannot be greater than maximum humidity";
      } else {
        this.isLoading = true;
        this.Errormssg = "";
        let deviceupdate;
        if (this.singledevice.type === "mote") {
          deviceupdate = {
            name: this.devicename,
            minTemperature: Number(this.mintemp),
            maxTemperature: Number(this.maxtemp),
            minHumidity: Number(this.minHumi),
            maxHumidity: Number(this.maxHumi),
            // interval: parseFloat(this.interval),
            description: this.deviceDescription,
            // status: this.status,
            location: this.location,
          };
        } else {
          deviceupdate = {
            name: this.devicename,
            minTemperature: Number(this.mintemp),
            maxTemperature: Number(this.maxtemp),
            // preset: Number(this.preset),
            // lock: this.boxstatus,
            minHumidity: Number(this.minHumi),
            maxHumidity: Number(this.maxHumi),
            description: this.deviceDescription,
            // interval: parseFloat(this.interval),
            // status: this.status,
            location: this.location,
          };
        }
        //console.log(deviceupdate, "update")
        this.updateDevice({
          device_id: this.singledevice.id,
          deviceupdate,
        })
          .then((res) => {
            this.fetchDeviceDetails({
              device_id: this.$route.params.device_id,
            });
            this.isLoading = false;
            this.mssg =
              res.data.message[0].toUpperCase() + res.data.message.slice(1);
            //console.log(res.data.message);
            setTimeout(() => {
              this.mssg = "";
            }, 2000);
          })
          .catch((error) => {
            this.isLoading = false;
            this.Errormssg =
              error.response.data.message[0].toUpperCase() +
              error.response.data.message.slice(1);
            // error.response can be null
            if (error.response) {
              console.error(error.response.data.message);
            }
          });
      }
    },
    maxWords(evt) {
      if (evt.target.value.length > 149) {
        evt.preventDefault();
        return;
      }
    },
  },
};
</script>

<style scoped>
.mylink {
  color: #494f54 !important;
}
.mylink :hover {
  color: #213e7a !important;
  text-decoration: underline;
  text-decoration-color: #213e7a !important;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>

<i18n>
{
	"en": {
		"dev_location": "Address (Device Location)",
		"int": "Interval",
		"lck-unlck": "Lock/Unlock",
		"left": "left",
		"locked": "Locked",
		"mins": "Minute(s)",
		"mk-pub-priv": "Make Device Private/Public",
		"priv": "Private",
		"public": "Public",
		"rate": "This is the rate at which you want your device to send in data",
		"set-point": "Set Point",
		"unlock": "Unlocked",
		"words": "words"
	},
	"es": {
		"dev_location": "Dirección (ubicación del dispositivo)",
		"int": "intervalo",
		"lck-unlck": "Bloqueo y desbloqueo",
		"left": "izquierda",
		"locked": "Bloqueado",
		"mins": "Minutos)",
		"mk-pub-priv": "Hacer que el dispositivo sea privado / público",
		"priv": "Privado",
		"public": "Público",
		"rate": "Esta es la velocidad a la que desea que su dispositivo envíe datos",
		"set-point": "Punto fijo",
		"unlock": "desbloqueado",
		"words": "palabras"
	},
	"fr": {
		"dev_location": "Adresse (emplacement de l'appareil)",
		"int": "Intervalle",
		"lck-unlck": "Verrouiller/Déverrouiller",
		"left": "La gauche",
		"locked": "Fermé à clef",
		"mins": "minutes)",
		"mk-pub-priv": "Rendre l'appareil privé/public",
		"priv": "privé",
		"public": "Publique",
		"rate": "Il s'agit de la vitesse à laquelle vous souhaitez que votre appareil envoie des données",
		"set-point": "Point de consigne",
		"unlock": "Débloqué",
		"words": "Mots"
	},
	"sw": {
		"dev_location": "Anwani (Mahali Kifaa)",
		"int": "Muda",
		"lck-unlck": "Funga/Fungua",
		"left": "Kushoto",
		"locked": "Imefungwa",
		"mins": "Dakika",
		"mk-pub-priv": "Fanya Kifaa Kibinafsi/Hadharani",
		"priv": "Privat",
		"public": "Umma",
		"rate": "Hiki ndicho kiwango ambacho ungependa kifaa chako kitume data",
		"set-point": "Weka Pointi",
		"unlock": "Imefunguliwa",
		"words": "Maneno"
	}
}
</i18n>
